import React, { useState, useContext, useEffect, useRef } from "react";

const TimerContext = React.createContext();

export const Timer = (props) => {
  const [seconds, setSeconds] = useState(0);
  const [isActive, setIsActive] = useState(true);

  const timersRef = useRef([]);
  const timers = timersRef.current;

  const start = (totalSeconds = 0) => {
    setSeconds(totalSeconds);
    setIsActive(true);
  };

  const stop = () => {
    setIsActive(false);
  };

  useEffect(() => {
    let id = null;
    if (isActive) {
      id = setTimeout(() => {
        setSeconds((seconds) => seconds + 1);
      }, 1000);
    } else if (!isActive) {
      clearTimeout(id);
    }
    return () => clearTimeout(id);
  }, [isActive, seconds]);

  return (
    <TimerContext.Provider
      value={{
        isActive,
        start,
        stop,
        timers: timers,
        anyTimer: () => anyTimer(timers),
        isTimerAvailable: (name) => isTimerAvailable(timers, name),
        addTimer(name, seconds = 3600) {
          addTimer(timers, { name, seconds });
        },
        removeTimer(name) {
          removeTimer(timers, name);
        },
      }}
    >
      {props.children}
    </TimerContext.Provider>
  );
};

const Count = (props) => {
  const context = useContext(TimerContext);
  const { timers, ...rest } = context;

  if (timers.filter((t) => t.name === props.on)) {
    const [timer] = timers.filter((t) => t.name === props.on);

    if (timer) {
      const Component = props.children;
      return (
        <Component
          {...rest}
          timeDelta={calcTimeDelta(
            timer.seconds - (new Date() - timer.ts) / 1000
          )}
          totalSeconds={timer.seconds}
        />
      );
    }
  }
  return null;
};

export const calcTimeDelta = (remindingSeconds, autoStop = true) => {
  if (remindingSeconds < 0 && autoStop) {
    remindingSeconds = 0;
  }
  return {
    remindingSeconds,
    days: Math.floor(remindingSeconds / (3600 * 24)),
    hours: Math.floor((remindingSeconds / 3600) % 24),
    minutes: Math.floor((remindingSeconds / 60) % 60),
    seconds: Math.floor(remindingSeconds % 60),
    completed: remindingSeconds <= 0,
  };
};

export const anyTimer = (timers) => timers.length > 0;

export const isTimerAvailable = (timers, timerName) =>
  timers.filter((t) => t.name === timerName).length > 0;

export const addTimer = (mutableTimers, timer) => {
  if (!isTimerAvailable(mutableTimers, timer.name)) {
    mutableTimers.push({ ...timer, ts: new Date() });
  }
};

export const removeTimer = (mutableTimers, timerName) => {
  const start = mutableTimers.findIndex((t) => t.name === timerName);
  if (start > -1) {
    mutableTimers.splice(start, 1);
  }
};

export const useTimer = () => {
  const context = useContext(TimerContext);
  return {
    ...context,
    Count: Count,
  };
};

export const withTimer = (Component) => {
  return function WrapperComponent(props) {
    return (
      <TimerContext.Consumer>
        {(context) => <Component {...props} {...context} />}
      </TimerContext.Consumer>
    );
  };
};
export default withTimer;
